import { render } from "./GradientLineChart.vue?vue&type=template&id=8820e904"
import script from "./GradientLineChart.vue?vue&type=script&lang=js"
export * from "./GradientLineChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/workspace/Deploy unapatitafeliz backend PROD/admin-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__